<script lang="ts">
  import type { HTMLAttributes } from 'vue'
  export interface DataListItemMetaProps {
    class?: HTMLAttributes['class']
  }
</script>

<script setup lang="ts">
  import { cn } from '@gat-ship/vue-components'
  const props = defineProps<DataListItemMetaProps>()
</script>

<template>
  <div :class="cn('text-soft shrink-0 text-right text-sm', props.class)">
    <slot />
  </div>
</template>
